import styled from "styled-components";
export const DiscountInfoBox = styled.section `
	box-sizing: border-box;
	position: absolute;
	height: 46px;
	width: 46px;
	top: 0;
	right: 0;
	background-image: url("https://i.ezbuy.sg/FlukT0zUakLJ5P1M9Mav8QUZRy_l");
	background-size: contain;
	background-repeat: no-repeat;
	text-align: center;
	font-size: 14px;
	font-weight: 500;
	color: #fff;
	line-height: 17px;
	padding-top: 3px;
	z-index: 1;
`;
export const SoldOutMask = styled.i `
	z-index: 2;
	position: absolute;
	width: 100%;
	height: 100%;
	background-image: url("https://i.ezbuy.sg/FqYYDIMV204CMj8fubheASMfXiJq");
	background-size: 50%;
	background-repeat: no-repeat;
	background-position: center;
	background-color: rgba(0, 0, 0, 0.4);
`;
